module.exports = __webpack_public_path__ + "static/assets/91f93cb8640f0af108b8c61866d5bd3f.png";